import { render, staticRenderFns } from "./ModalAddEditCateringService.vue?vue&type=template&id=2b00e9d0&scoped=true&"
import script from "./ModalAddEditCateringService.vue?vue&type=script&lang=js&"
export * from "./ModalAddEditCateringService.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddEditCateringService.vue?vue&type=style&index=0&id=2b00e9d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00e9d0",
  null
  
)

export default component.exports